// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation_wrapper__6iXuJ","root":"Navigation_root__CC1gy","container":"Navigation_container__4s3vI","scrollable":"Navigation_scrollable__wUrYp"};